import { render, staticRenderFns } from "./VoucherExpiration.vue?vue&type=template&id=a7158964&scoped=true&"
import script from "./VoucherExpiration.vue?vue&type=script&lang=js&"
export * from "./VoucherExpiration.vue?vue&type=script&lang=js&"
import style0 from "./VoucherExpiration.vue?vue&type=style&index=0&id=a7158964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7158964",
  null
  
)

export default component.exports